import { render, staticRenderFns } from "./AdminBaseDashboard.vue?vue&type=template&id=3fc330ed&scoped=true"
import script from "./AdminBaseDashboard.vue?vue&type=script&lang=js"
export * from "./AdminBaseDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminBaseDashboard.vue?vue&type=style&index=0&id=3fc330ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc330ed",
  null
  
)

export default component.exports